import type { ChatWidget } from '../../types/coach';
import { TextWidget } from './TextWidget';
import { ProductWidget } from './ProductWidget';
import { SponsorWidget } from './SponsorWidget';
import { ContactWidget } from './ContactWidget';
import { ChartWidget } from './ChartWidget';

interface ChatWidgetRendererProps {
  widget: ChatWidget;
}

export function ChatWidgetRenderer({ widget }: ChatWidgetRendererProps) {
  switch (widget.type) {
    case 'text':
      return <TextWidget widget={widget} />;
    case 'product':
      return <ProductWidget widget={widget} />;
    case 'sponsor':
      return <SponsorWidget widget={widget} />;
    case 'contact':
      return <ContactWidget widget={widget} />;
    case 'chart':
      return <ChartWidget widget={widget} />;
    default:
      return (
        <div className="text-danger text-sm">
          Unknown widget type: {(widget as { type: string }).type}
        </div>
      );
  }
}